import { render, staticRenderFns } from "./ExtendableLink.vue?vue&type=template&id=8dc556f2&"
import script from "./ExtendableLink.vue?vue&type=script&lang=js&"
export * from "./ExtendableLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports